import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)<{ backgroundImage?: string }>`
  ion-content {
    --background: url(${(props) =>
        props.backgroundImage ||
        '/assets/layout-own-ai-dominate-v2/jia/welcome/main-image.png'})
      no-repeat center center / cover;
    --padding-bottom: 18px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url(/assets/layout-own-ai-dominate-v2/welcome/glowing.png)
        no-repeat center center / cover;
      z-index: 1;
      pointer-events: none;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url(/assets/layout-own-ai-dominate/welcome/glowing-overlay.png)
        no-repeat center center / cover;
      z-index: 1;
      pointer-events: none;
    }

    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
      position: relative;
      z-index: 2;
    }

    .app-logo {
      width: 131px;
      height: 30px;
      margin: 0 0 32px;
    }
  }
`;

export const WelcomeBannerStyles = styled.div<{ src?: string }>`
  width: 100%;
  height: 100%;
  max-height: 80px;
  max-width: 275px;
  background: url(${(props) =>
      props.src || '/assets/layout-own-ai-dominate/welcome/header.png'})
    no-repeat center center / contain;
  aspect-ratio: 320 / 220;
  position: relative;
  z-index: 3;
`;

export const WelcomeDescriptionStyles = styled(UiTypography)`
  text-align: center;
  margin: 8px 16px 16px;
`;

export const ContentContainerStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: auto;
  position: relative;
  z-index: 2;
`;
